import React, { FC } from "react";
import "./ModalOffCanvas.scss";

interface ModalOffCanvasProps {
  show: boolean;
  onClose?: any;
  title?: string;
  body?: React.ReactNode;
}

const ModalOffCanvas: FC<ModalOffCanvasProps> = ({
  show,
  onClose,
  title,
  body,
}) => {
  return (
    <div className="ModalOffcanvas" data-testid="ModalOffcanvas">
      {show && (
        <div className="offcanvas-backdrop fade show" onClick={onClose}></div>
      )}
      <div
        className={`offcanvas offcanvas-end ${show ? "show" : ""}`}
        tabIndex={-1}
        style={{ visibility: show ? "visible" : "hidden" }}
      >
        <div className="offcanvas-header">
          <h4>{title}</h4>
          <a type="button" onClick={onClose}>
            <i className="fa fa-close"></i>
          </a>
        </div>
        <div className="offcanvas-body">{body}</div>
      </div>
    </div>
  );
};

export default ModalOffCanvas;
